<template>
  <Form v-slot="{ errors }" @submit="onSubmit">
    <div class="my-3 text-center">
      <div
        class="bg-gray-450 p-4 md:w-full pl-6 rounded-full w-8/12 xs:w-full sm:w-full lg:w-10/12 flex items-center"
        :class="{ active: isActive }"
      >
        <Field
          name="paymentMethod"
          type="radio"
          value="efectivo"
          class="mr-3"
          :model-value="modelValue"
          @update:model-value="$emit('update:modelValue', $event)"
        />
        <label for="paymentMethod" class="font-medium">Pago en Efectivo</label>
      </div>
      <div
        v-if="isActive"
        class="bg-gray-450 p-4 md:w-full pt-6 pl-6 rounded-br-3xl rounded-bl-3xl transition-all"
      >
        <p class="text-sm">
          Paga en cualquiera de nuestros lugares de pago presentando el
          siguiente código de barras:
        </p>
        <img :src="barcode.qr_code" alt="barcode" class="mx-auto my-5" />
        <p class="text-center text-lg font-bold">{{ barcode.referencia }}</p>
        <p class="text-center underline mt-4 text-xs">
          Una vez realizado el pago tu paquete quedara habilitado
        </p>
        <div class="text-center">
          <button class="btn btn-red my-5 mx-auto" type="submit">
            Enviar a mi celular
          </button>
        </div>
        <PaymentStores />
      </div>
    </div>
  </Form>
</template>

<script setup>
import { computed } from 'vue';
import { Form, Field } from 'vee-validate';
import PaymentStores from './PaymentStores.vue';

const props = defineProps({
  modelValue: String,
  barcode: Object,
  onSubmit: Function
});

defineEmits(['update:modelValue']);

const isActive = computed(() => props.modelValue === 'efectivo');
</script>

<style scoped>
.active {
  @apply rounded-br-none rounded-bl-none bg-red text-white rounded-tr-2xl rounded-tl-2xl w-full;
}
</style>
